<template>
<!-- 常用功能导航 -->
    <div class="auto-cad">
        <transition name="fade">
            <div class="frequently" v-if="showbox">
                <div class="auto-cad-nav">
                    <div class="nav-head">
                        <span>常用功能</span>
                        <span @click="hide"><i class="el-icon-d-arrow-right"></i></span>
                    </div>
                    <ul class="freList" :style="{'overflow-y':getNavLint.length>10 ? 'scroll' : 'unset'}" v-if="getNavLint && getNavLint.length>0">
                        <li v-for="(item,index) in getNavLint" :key="index">
                            <el-link :href="item.url" :underline="false">{{item.nav_name}}</el-link>
                        </li>
                        <div class="linkbottom">
                            <span @click="editNav">修改</span>
                        </div>
                    </ul>
                    <div class="nothing" v-else>
                        <img src="../assets/nothing.png" alt="">
                        <p>未添加常用功能</p>
                        <a href="javascript:;" @click="editNav">立即添加</a>
                    </div>
                </div>
            </div>
        </transition>
        
        <div class="ac-bt">
            <img @click="showSet = !showSet" src="../assets/littelU.png" alt="">
            <div v-if="showSet" class="setnav" @click="showbox = !showbox">常用功能</div>
            <el-backtop :right='9'></el-backtop>
        </div>
         <el-dialog :visible.sync="showModal"
            width="90%" @close="cancal('form')">
            <div class="setbox">
                <el-form ref="form" :model="form">
                    <div class="scrolld">
                    <el-form-item v-for="(item,index) in freqList" :key="index" prop="checkList">
                        <p :style="{borderColor:colorList[index],color:colorList[index]}">{{item.name}}</p>
                        <el-checkbox-group v-model="form.checkList" @change="checkchange">
                            <el-checkbox v-for="(i,index) in item" :key="index" :label="i.id" :value="i.id">{{i.nav_name}}</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item prop="checkList2">
                        <p :style="{borderColor:colorList[7],color:colorList[7]}">部门定制</p>
                        <el-checkbox-group v-model="form.checkList2" @change="checkchange">
                            <el-checkbox v-for="(item,index) in list[0]" :key="index" :label="item.id" :value="item.id">{{item.nav_name}}</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    </div>
                    <el-form-item>
                        <el-button :disabled='disabled' type="primary" @click="onSubmit">确定</el-button>
                        <el-button @click="showModal = !showModal;cancal('form')">取消</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import store from '../store'
import { mapGetters } from 'vuex'
export default {
    name:'RightNavbar',
    props:['navListAll'],
    computed: {
        ...mapGetters([
            'userName'
        ]),
        getNavLint(){
            return this.$store.state.user.menus
        }
    },
    data(){
        return{
            showbox:false,
            showSet:false,
            showModal:false,
            colorList:['#e60012','#13B5B1','#009944','#8FC31F','#F39800','#008DF6','#009944','#00479D'],
            freqList:[],
            list:[],
            form: {
               checkList:[],
               checkList2:[]
            },
            disabled:false,
        }
    },
    methods:{
        hide(){
            this.$parent.playbox()
        },
        cancal(formName){
            this.$refs[formName].resetFields();
        },
        editNav(){
            this.showModal = true
            this.getNavlist()
        },
        getNavlist(){//获取网站导航
            let arr = []
            for(var i in this.navListAll){
                this.navListAll[i]['name'] = i
                arr.push(this.navListAll[i])
            }
            this.list = arr.filter(e=>{ return e.name == "部门定制" })
            this.freqList = arr.filter(e=>{return  e.name != "部门定制" })
            this.form.checkList = []
            this.form.checkList2 = []
            this.checkedList(2,this.list)
            this.checkedList(1,this.freqList)
        },
        checkedList(type,arr){
            let narr = []            
            this.getNavLint.map(v=>{
               narr.push(v.nav_name)
            }) 
            arr.map(m=>{
                m.map(e=>{
                    if(narr.indexOf(e.nav_name)!=-1){
                        switch (e.type){
                            case 1:
                                this.form.checkList.push(e.id)
                            break;
                            case 2:
                                this.form.checkList2.push(e.id)
                            break;
                        }
                    }
                })
            })
            if(this.form.checkList.length + this.form.checkList2.length > 0 ){
                this.disabled = false
            }else{
                this.disabled = true
            }
        },
        // 改变提交按钮状态
        checkchange(val){
            this.disabled = this.form.checkList.length + this.form.checkList2.length > 0 ? false :true
        },
        // 修改常用功能
        onSubmit(){
            let data = {
                'nav':this.form.checkList.toString(),
                'nav_made':this.form.checkList2.toString()
            }
             this.$http({
                url:this.$http.adornUrl(`common/setOftenNav`),
                method: 'post',
                data:data
            }).then(({data})=>{
                if(data.code==1){
                    this.$message({
                        message: '修改成功！',
                        type: 'success'
                    });
                    store.dispatch('user/getMenus')
                    this.showModal = false
                }
            })
        }
    }
}
</script>
<style lang='scss' scoped>
.ac-bt{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: fixed;
    right: 0;
    bottom:90px;
    z-index: 9;
    width:60px;
    .setnav{
        cursor: pointer;
        font-weight: 600;
        padding:10px;
        width: 100%;
        box-sizing: border-box;
        color: #e60012;
        background: #ffffff;
        box-shadow: 2px 2px 10px 1px rgba(0,0,0,.2);
        &:hover{
            color:#ffffff;
            background: rgba(230, 0, 18 ,.8);
        }
    }
    &>>>.el-backtop{
        color: #e60816;
        box-shadow: 0 0 6px #f0606d;
    }
}
.frequently{
    position: fixed;
    z-index:9;
 .auto-cad-nav{
    position: fixed;
    right: 2%;
    top: 40%;
    transform: translateY(-50%);
    border:2px solid #FB3960;
    width: 120px;
    height: 280px;
    background: #fff;
    .nav-head{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding:4px 8px;
        font-size: 14px;
        color: #fff;
        background:#FB3960;
    }
    .freList{
        padding:10px 0 10px 10px;
        text-align: left;
        overflow: hidden;
        height: 90%;
        padding-bottom: 30px;
        li{
            margin-bottom: 4px;
            a{
                font-size: 13px;
            }
        }
       .linkbottom{
            position: absolute;
            bottom: 0;
            background: #ffffff;
            z-index: 9;
            text-align: right;
            padding:5px 0;
            width:80%;
            span{
                color: #409EFF;
                cursor: pointer;
                font-size: 14px;
                &:hover{
                    color: #FB3960;
                }
            }
        } 
    }
    
    .nothing{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        img{
            margin: 20px;
            width: 70%;
        }
        p{
            font-size: 12px;
            color: #555555;
            margin-bottom: 10px;
        }
        a{
            color: #FB3960;
            position: relative;
            &::after{
                content:' ';
                position: absolute;
                left: 0;
                right: 0;
                bottom: 0;
                height: 1px;
                width: 0;
                margin:0 auto;
                background: #FB3960;
                transition: 0.3s;
            }
            &:hover:after{
                width: 100%;
            }
        }
    }
 }
}

.setbox{
    &>>>.el-form-item{
        margin-bottom: 0!important;
    }
    &>>>.el-form-item__content{
        line-height: 28px!important;
    }
    &>>>.el-button{
        margin:6px 8px 6px 0;
    }
    .scrolld{
        max-height:700px;
        overflow: hidden;
        overflow-y:scroll;
    }
    p{
    line-height: 28px;
        margin-bottom: 4px;
        color: #fff;
        display: inline-block;
        border-radius: 4px;
        padding: 1px 0;
        border: 1px solid;
        width:90px;
        text-align: center;
    }
}

/deep/.el-link.el-link--default{
    position: relative;
    &::after{
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        width: 0;
        margin: 0 auto;
        height: 1px;
        background: #FB3960;
        transition: 0.3s;
    }
}
/deep/.el-link.el-link--default:hover{
    color: #FB3960;
    &::after{
        width: 100%;
    }
}
.fade-enter,.fade-leave-to{
    opacity: 0;
}
.fade-enter-active,.fade-leave-active{
    transition: opacity 0.3s;
}

</style>


// WEBPACK FOOTER //
// src/components/RightNavbar.vue